import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { forwardRef } from 'react';

import styles from './Arrow.css';

type TDirection = -1 | 1;

interface IArrowProps {
  direction: TDirection;
}

export const Arrow = forwardRef(({ direction }: IArrowProps, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div
      className={clsx(styles['click_area'], direction < 0 && styles['click_area--left'])}
      data-testid="carousel_arrow"
      ref={ref}
    >
      <div className={styles['background']}>
        <div className={styles['icon_container']}>
          <div className={styles['icon']}>
            {direction < 0 ? (
              <IconActionChevronLeft16 color="icon-secondary-default" data-testid="icon_arrow_left" />
            ) : (
              <IconActionChevronRight16 color="icon-secondary-default" data-testid="icon_arrow_right" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

Arrow.displayName = 'Arrow';
